import { trainerApi } from '@/api/trainer.api';
import { Store } from 'vuex';
import { FilteredTrainerPayload, TrainerState } from './trainer.types';

export const trainerActions = {
  async getTrainers(store: Store<TrainerState>) {
    try {
      store.commit('GET_TRAINERS_LOADING');

      const { data } = await trainerApi.getTrainers();

      store.commit('GET_TRAINERS_SUCCESS', data);
    } catch (error) {
      store.commit('GET_TRAINERS_ERROR', error);
    }
  },
  async getPaginatedTrainers(
    store: Store<TrainerState>,
    payload: FilteredTrainerPayload
  ) {
    try {
      store.commit('GET_PAGINATED_TRAINERS_LOADING');

      const { data } = await trainerApi.getPaginatedTrainers(payload);

      store.commit('GET_PAGINATED_TRAINERS_SUCCESS', data);

      return data;
    } catch (error) {
      store.commit('GET_PAGINATED_TRAINERS_ERROR', error);
      throw error;
    }
  }
};
